const SkipShipment = (props) => {
  const { clubMemberShipment, onModal } = props;

  const handleSkipShipment = (e) => {
    e.preventDefault();
    onModal('skipTraditionalShipment');
  };

  const handleUnskipShipment = (e) => {
    e.preventDefault();
    onModal('unskipTraditionalShipment');
  };

  if (clubMemberShipment.processingStatus === 'Pending') {
    return (
      <a onClick={handleSkipShipment} className="c7-club-actions__skip">
        Skip this shipment
      </a>
    );
  }

  if (clubMemberShipment.processingStatus === 'Skip') {
    return (
      <a onClick={handleUnskipShipment} className="c7-club-actions__unskip">
        Unskip this shipment
      </a>
    );
  }
  return null;
};

export default SkipShipment;
